import { render } from "./RemoveEntryIcon.vue?vue&type=template&id=d943c1a6"
import script from "./RemoveEntryIcon.vue?vue&type=script&lang=js"
export * from "./RemoveEntryIcon.vue?vue&type=script&lang=js"
script.render = render

export default script